import './post.css';
// import { fabric } from 'fabric';
import Like from '../like/Like'; // adjust the path as needed
import MyFriendsToSharePost from '../../components/myFriendsToSharePost/MyFriendsToSharePost';
import { MoreVert } from '@material-ui/icons';
import { IconButton, MenuItem, Menu } from '@material-ui/core';
import {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';
//import { Button, Comment, Form, Header } from 'semantic-ui-react';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import axiosConn from '../../axiosConn';
import { CircularProgress } from '@material-ui/core';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DynamicHtml from '../dynamicHtml/DynamicHtml';
import Comment from '../comment/Comment';
import CreateComment from '../createComment/CreateComment';
// import { format } from 'timeago.js';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useMediaQuery } from 'react-responsive';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import HearingIcon from '@mui/icons-material/Hearing';
import { Tooltip } from '@mui/material';
// import { ClipLoader } from 'react-spinners';
import Modal from '../modal/Modal';
import checkHtmlDialogElement from '../../utils/checkHtmlDialogElement';
import playSound from '../../utils/playSound';
import { SocketContext } from '../../context/socket';
import { ViewPortContext } from '../../context/ViewPortContext';
import Form from 'react-bootstrap/Form';

import preciseFormat from '../../utils/preciseFormat';
import PostMediaCarousel from './PostMediaCarousel';
import { useTheme } from '../../context/ThemeContext';
import useStyles from '../../utils/useStyles';
import { Room } from '@material-ui/icons';
import ReactionBar from '../reactionBar/ReactionBar';
import './localops-post.css';
import '../../styles/jgLocalOpsBadge.css';
import JGLocalOpsMark from '../common/JGLocalOpsMark';
import getDistanceFromLatLonInMeters from '../../utils/getDistanceFromLatLonInMeters';
import getShareUrl from '../../utils/getShareUrl';
import { isSafeAuthReturnTo } from '../../utils/authReturnTo';
import { removeCommentById } from '../../utils/commentRealtime';
import {
  applyPostEditToPost,
  getPostRealtimeId,
  mergeUntrustedPostUpdate,
} from '../../utils/postRealtime';
import {
  getMediaThumbnailUrl,
  normalizeMediaList,
} from '../../utils/postMediaUtils';
import isVideoFile from '../../utils/isVideoFile';
import { setJGRadioCue } from '../../pages/hitlab/hitLabRadioCue';
import { shouldShowJGRadioDock } from '../../pages/hitlab/jgRadioDockVisibility';

const winningSound =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1713899521/y2mate_HrgsElu_gxito3.mp3';

const POST_EDIT_MAX_LENGTH = 2000;
const POST_EDIT_MAX_MEDIA = 10;
const POST_EDIT_FILE_ACCEPT = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp',
  '.avif',
  '.heic',
  '.heif',
  '.mp4',
  '.m4v',
  '.webm',
  '.ogg',
  '.ogv',
  '.mov',
  '.flv',
  '.3gp',
  '.3g2',
  '.avi',
  '.mkv',
].join(',');

const hasPlayerLiked = (likes = [], playerId = '') =>
  Array.isArray(likes) &&
  likes.some((likePlayerId) => String(likePlayerId) === String(playerId));

const normalizePostAuthorValue = (value) => {
  const text = String(value || '').trim();
  const lowered = text.toLowerCase();
  if (
    !text ||
    lowered === 'null' ||
    lowered === 'undefined' ||
    lowered === 'nan' ||
    lowered === 'none' ||
    lowered === 'false' ||
    text === '[object Object]'
  ) {
    return null;
  }
  return text;
};

const resolvePostProfilePhoto = (...candidates) => {
  for (const candidate of candidates) {
    const normalized = normalizePostAuthorValue(candidate);
    if (normalized) return normalized;
  }
  return null;
};

const resolvePostAuthor = (post) => {
  if (!post || typeof post !== 'object') return null;
  const author = post.author || null;
  const playerId =
    author?.playerId ||
    author?._id ||
    post.playerId ||
    post.user?.playerId ||
    post.creator?.playerId ||
    post.userId?.playerId ||
    null;
  const profilePhoto =
    resolvePostProfilePhoto(
      author?.profilePhoto,
      author?.profilePicture,
      author?.avatar,
      post.profilePhoto,
      post.profilePicture,
      post.avatar,
      post.user?.profilePhoto,
      post.user?.profilePicture,
      post.user?.avatar,
      post.creator?.profilePhoto,
      post.creator?.profilePicture,
      post.creator?.avatar,
      post.userId?.profilePhoto,
      post.userId?.profilePicture,
      post.userId?.avatar,
    ) || null;
  const rawId =
    author?._id ||
    post.userId?._id ||
    post.creator?._id ||
    post.user?._id ||
    (typeof post.userId === 'string' ? post.userId : null) ||
    (typeof post.creator === 'string' ? post.creator : null) ||
    null;
  const resolvedPlayerId = normalizePostAuthorValue(playerId);
  const resolvedProfilePhoto = normalizePostAuthorValue(profilePhoto);
  const resolvedId =
    normalizePostAuthorValue(rawId) || resolvedPlayerId || null;
  if (!resolvedPlayerId && !resolvedProfilePhoto) return null;
  return {
    playerId: resolvedPlayerId || null,
    profilePhoto: resolvedProfilePhoto || null,
    _id: resolvedId || null,
  };
};

const isBlockedPostEditMediaUrl = (url = '') =>
  /^(blob|data|javascript):/i.test(String(url || '').trim());

const toFinitePostEditNumber = (value) => {
  const number = Number(value || 0);
  return Number.isFinite(number) && number >= 0 ? number : 0;
};

const makePostEditMediaDraft = (item) =>
  normalizeMediaList(item)
    .slice(0, POST_EDIT_MAX_MEDIA)
    .map((media, index) => ({
      id: `existing-${index}-${media.url}`,
      persisted: true,
      url: media.url,
      type: media.type || (isVideoFile(media.url) ? 'video' : 'image'),
      width: toFinitePostEditNumber(media.width),
      height: toFinitePostEditNumber(media.height),
      duration: toFinitePostEditNumber(media.duration),
      size: toFinitePostEditNumber(media.size),
      thumbnailUrl: media.thumbnailUrl || '',
    }));

const toPostEditMediaPayload = (item) => ({
  url: item.url,
  type: item.type || (isVideoFile(item.url) ? 'video' : 'image'),
  width: toFinitePostEditNumber(item.width),
  height: toFinitePostEditNumber(item.height),
  duration: toFinitePostEditNumber(item.duration),
  size: toFinitePostEditNumber(item.size),
});

const getPostEditMediaSignature = (items = []) =>
  JSON.stringify(
    items.map((item) => ({
      url: item.url || item.preview || '',
      type: item.type || '',
    })),
  );

const revokePostEditDraftPreviews = (items = []) => {
  items.forEach((item) => {
    if (item?.preview && String(item.preview).startsWith('blob:')) {
      URL.revokeObjectURL(item.preview);
    }
  });
};

const normalizeLocalOpsMeta = (post) => {
  const meta = post?.meta || {};
  if (meta.localops) {
    return {
      ...meta.localops,
      contextId:
        meta.localops.contextId ||
        post?.contextId ||
        meta.contextId ||
        null,
      entityId:
        meta.localops.entityId ||
        post?.contextId ||
        meta.entityId ||
        null,
    };
  }
  if (post?.context && post.context.startsWith('localops.')) {
    return {
      entityType: post.context.replace('localops.', ''),
      shareUrl: post?.meta?.shareUrl || null,
      contextId: post?.contextId || post?.meta?.contextId || null,
      entityId: post?.contextId || post?.meta?.entityId || null,
      regionLabel: post?.meta?.regionLabel || null,
      status: post?.meta?.status || null,
      priceUsd: post?.meta?.priceUsd || null,
      priceJGK: post?.meta?.priceJGK || null,
      owner: post?.meta?.owner || null,
      task: post?.meta?.task || null,
      offering: post?.meta?.offering || null,
    };
  }
  return null;
};

const buildRadioRotationDropUrl = (trackId) =>
  trackId
    ? `/hitlab/radio?track=${encodeURIComponent(
        trackId,
      )}&source=jg-radio-rotation-drop`
    : null;

const normalizeRadioRotationDropUrl = (value, trackId) => {
  const fallback = buildRadioRotationDropUrl(trackId);
  const raw = String(value || fallback || '').trim();
  if (!raw) return null;
  try {
    const parsed = new URL(raw, 'https://www.joegalaxy.net');
    if (parsed.pathname !== '/hitlab/radio') return fallback;
    const relativeUrl = `${parsed.pathname}${parsed.search}${parsed.hash}`;
    return isSafeAuthReturnTo(relativeUrl) ? relativeUrl : fallback;
  } catch (err) {
    return fallback;
  }
};

const normalizeHitLabRadioRotationDropMeta = (post) => {
  const raw = post?.meta?.hitlabRadioRotationDrop || null;
  const isRotationDropPost = post?.context === 'hitlab.radio.rotation_drop';
  if (!raw && !isRotationDropPost) return null;

  const trackId = normalizePostAuthorValue(raw?.trackId || post?.contextId);
  const cta = raw?.cta || {};
  const ctaUrl = normalizeRadioRotationDropUrl(cta.url, trackId);
  if (!trackId || !ctaUrl) return null;
  const label = normalizePostAuthorValue(cta.label);

  return {
    trackId,
    songTitle:
      normalizePostAuthorValue(raw?.songTitle) ||
      normalizePostAuthorValue(post?.title) ||
      'JG Radio record',
    artistName: normalizePostAuthorValue(raw?.artistName) || '',
    label: !label || label === 'Hear the song' ? 'Listen to the song' : label,
    url: ctaUrl,
  };
};

const buildLocationChip = ({ post, viewerLat, viewerLon }) => {
  const rawRegion = post?.meta?.regionLabel || '';
  const rawAddress = post?.location?.address || '';
  const source = rawRegion || rawAddress || '';

  const sanitize = (input) => {
    const tokens = String(input || '')
      .split(',')
      .map((p) => p.trim())
      .filter(Boolean)
      // drop tokens that contain digits (street numbers, ZIPs)
      .filter((p) => !/\d/.test(p));
    if (tokens.length >= 2) return `${tokens[tokens.length - 2]}, ${tokens[tokens.length - 1]}`;
    if (tokens.length === 1) return tokens[0];
    return '';
  };

  const coarseLabel = sanitize(source) || 'Local';

  const hasCoords =
    post?.location?.coordinates &&
    Array.isArray(post.location.coordinates) &&
    post.location.coordinates.length === 2;
  if (!hasCoords) return coarseLabel;

  const [lon, lat] = post.location.coordinates;
  if (
    Number.isFinite(lat) &&
    Number.isFinite(lon) &&
    Number.isFinite(viewerLat) &&
    Number.isFinite(viewerLon)
  ) {
    const dist = getDistanceFromLatLonInMeters(viewerLat, viewerLon, lat, lon);
    const nearby = Number.isFinite(dist) && dist <= 40233.5; // 25 mi
    return nearby ? `Nearby · ${coarseLabel}` : coarseLabel;
  }
  return coarseLabel;
};

const normalizeLocalOpsId = (value) => {
  if (!value) return null;
  const raw =
    typeof value === 'object' ? value._id || value.id || value.taskId || value.offeringId : value;
  const text = String(raw || '').trim();
  if (
    !text ||
    text === '[object Object]' ||
    text.toLowerCase() === 'null' ||
    text.toLowerCase() === 'undefined'
  ) {
    return null;
  }
  return text;
};

const parseLocalOpsShareTarget = (shareUrl) => {
  if (!shareUrl) return null;
  const match = String(shareUrl).match(/\/share\/(task|offering)\/([^/?#]+)/i);
  if (!match) return null;
  return {
    type: match[1].toLowerCase(),
    id: decodeURIComponent(match[2]),
  };
};

const getLocalOpsEntityTarget = (localops) => {
  if (!localops) return null;
  const shareTarget = parseLocalOpsShareTarget(localops.shareUrl);
  const type =
    shareTarget?.type ||
    (localops.entityType === 'offering' ? 'offering' : 'task');
  const entity = type === 'offering' ? localops.offering : localops.task;
  const id = normalizeLocalOpsId(
    shareTarget?.id ||
      entity?.id ||
      entity?._id ||
      entity?.taskId ||
      entity?.offeringId ||
      localops.taskId ||
      localops.offeringId ||
      localops.entityId ||
      localops.contextId ||
      localops.id ||
      localops._id,
  );
  if (!type || !id) return null;
  return { type, id };
};

const buildLocalOpsLink = (localops) => {
  if (!localops) return null;
  const shareUrl = localops.shareUrl || null;
  const continueUrl = localops.continueUrl || null;
  const target = getLocalOpsEntityTarget(localops);
  const link = {};
  if (target) {
    link.map = target;
    link.share = shareUrl || `/share/${target.type}/${target.id}`;
  } else if (shareUrl) {
    link.share = shareUrl;
  }
  if (continueUrl) {
    link.continue = continueUrl;
    if (!link.share && !target) link.share = continueUrl;
  }
  return link.map || link.share || link.continue ? link : null;
};

const buildLocalOpsOwnerProfileTarget = (owner, isAuthed) => {
  const ownerPlayerId = normalizePostAuthorValue(owner?.playerId);
  if (!ownerPlayerId) return null;
  const profilePath = `/profile/${encodeURIComponent(ownerPlayerId)}`;
  if (!isSafeAuthReturnTo(profilePath)) return null;
  return isAuthed ? profilePath : `/login?returnTo=${encodeURIComponent(profilePath)}`;
};

export default function Post({
  galaxy = null,
  initialPost,
  onDelete,
  onUpdate = () => {},
  // handlePostClick
  isShareLanding = false,
  primaryCtaOverride = null,
  continuationOverride = null,
  onLocalOpsPrimaryCta = null,
  localOpsPresentation = 'default',
  localOpsExpanded = false,
  onLocalOpsToggle = null,
}) {
  // console.log(initialPost);
  const authCtx = useContext(AuthContext) || {};
  const location = useLocation();
  const fallbackPlayer = useMemo(
    () => ({
      data: {
        player: {
          _id: null,
          playerId: '',
          friends: [],
          jgkTokens: 0,
        },
      },
      token: null,
    }),
    [],
  );
  const loggedInPlayer = authCtx.player || fallbackPlayer;
  const currentPlayer = authCtx.player || fallbackPlayer;
  const [post, setPost] = useState(initialPost);
  const [isEditingPost, setIsEditingPost] = useState(false);
  const [editDesc, setEditDesc] = useState('');
  const [editMediaDraft, setEditMediaDraft] = useState(() =>
    makePostEditMediaDraft(initialPost),
  );
  const [editUploadProgress, setEditUploadProgress] = useState(0);
  const [editError, setEditError] = useState('');
  const [isSavingEdit, setIsSavingEdit] = useState(false);
  const previousPostIdRef = useRef(getPostRealtimeId(initialPost));
  const isEditingPostRef = useRef(false);
  const editMediaDraftRef = useRef(editMediaDraft);
  const editFileInputRef = useRef(null);
  const editUploaderRef = useRef(null);
  const checkbox = useRef();

  const [like, setLike] = useState(post?.likes?.length || 0);
  const [share, setShare] = useState(
    (post?.rePosts?.length || 0) + (post?.reShares?.length || 0),
  );
  const [jgkd, setJgkd] = useState(post?.jgkd?.length || 0);
  // const [isJgkd, setIsJgkd] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  // const [isShared, setIsShared] = useState(false);

  const [views, setViews] = useState(post?.views);

  const [player, setPlayer] = useState(
    () => resolvePostAuthor(initialPost) || {},
  );
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const currentPlayerId =
    currentPlayer?.data?.player?.playerId ||
    currentPlayer?.data?.playerId ||
    currentPlayer?.playerId ||
    '';
  const currentPlayerHasLikedPost = useMemo(
    () => hasPlayerLiked(post?.likes, currentPlayerId),
    [post?.likes, currentPlayerId],
  );
  const currentPlayerDbId =
    currentPlayer?.data?.player?._id ||
    currentPlayer?.data?._id ||
    currentPlayer?._id ||
    '';
  const localOpsMeta = useMemo(() => normalizeLocalOpsMeta(post), [post]);
  const radioRotationDropMeta = useMemo(
    () => normalizeHitLabRadioRotationDropMeta(post),
    [post],
  );
  const handleRadioRotationDropClick = (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
    ) return;
    if (
      !radioRotationDropMeta?.trackId ||
      !shouldShowJGRadioDock({
        pathname: location.pathname,
        isAuthenticated: Boolean(currentPlayer?.token),
      })
    ) return;

    event.preventDefault();
    setJGRadioCue({
      trackId: radioRotationDropMeta.trackId,
      source: 'jg-radio-rotation-drop',
    });
  };
  const postAuthorPlayerId = normalizePostAuthorValue(
    post?.playerId || player?.playerId,
  );
  const isOriginalPostAuthor =
    Boolean(postAuthorPlayerId && currentPlayerId) &&
    String(postAuthorPlayerId) === String(currentPlayerId);
  const canEditPost = Boolean(!localOpsMeta && post?._id && isOriginalPostAuthor);
  const getPostEditUploader = async () => {
    if (!editUploaderRef.current) {
      const { createMediaUploader } = await import('../../utils/mediaUpload');
      editUploaderRef.current = createMediaUploader();
    }
    return editUploaderRef.current;
  };
  const currentPostMediaSignature = useMemo(
    () => getPostEditMediaSignature(makePostEditMediaDraft(post)),
    [post],
  );
  const editMediaSignature = useMemo(
    () => getPostEditMediaSignature(editMediaDraft),
    [editMediaDraft],
  );
  const isEditMediaChanged = editMediaSignature !== currentPostMediaSignature;
  const postHasMediaForEdit = editMediaDraft.length > 0;
  const editCharsRemaining = POST_EDIT_MAX_LENGTH - editDesc.length;
  const isEditDescTooLong = editDesc.length > POST_EDIT_MAX_LENGTH;
  const isEditDescEmptyBlocked =
    !postHasMediaForEdit && editDesc.trim().length === 0;
  const isEditUnchanged =
    editDesc === (post?.desc || '') && !isEditMediaChanged;
  const canSavePostEdit =
    canEditPost &&
    !isSavingEdit &&
    !isEditDescTooLong &&
    !isEditDescEmptyBlocked &&
    !isEditUnchanged;
  const localOpsLink = useMemo(() => buildLocalOpsLink(localOpsMeta), [localOpsMeta]);
  const localOpsOwnerDisplay = useMemo(() => {
    return (
      normalizePostAuthorValue(localOpsMeta?.owner?.displayName) ||
      normalizePostAuthorValue(localOpsMeta?.owner?.playerId) ||
      normalizePostAuthorValue(player?.playerId) ||
      'LocalOps'
    );
  }, [localOpsMeta, player?.playerId]);
  const localOpsOwnerProfileTarget = useMemo(
    () => {
      if (!isShareLanding || localOpsMeta?.entityType !== 'offering') return null;
      return buildLocalOpsOwnerProfileTarget(
        localOpsMeta?.owner,
        Boolean(currentPlayer?.token),
      );
    },
    [currentPlayer?.token, isShareLanding, localOpsMeta],
  );
  const localOpsCommunityTask = useMemo(
    () =>
      localOpsMeta?.entityType === 'task' &&
      (localOpsMeta?.communityTask === true ||
        localOpsMeta?.task?.communityTask === true ||
        String(
          localOpsMeta?.paymentMode || localOpsMeta?.task?.paymentMode || '',
        ).toLowerCase() === 'community'),
    [localOpsMeta],
  );
  const actionableCommunityShareLanding =
    isShareLanding &&
    localOpsCommunityTask &&
    localOpsMeta?.actionType === 'accept';
  const paymentDisplay = useMemo(() => {
    if (!localOpsMeta) return { priceLine: null, escrowLine: null };
    if (localOpsCommunityTask) return { priceLine: null, escrowLine: null };
    const isTask = localOpsMeta.entityType === 'task';
    const parseNumber = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    };
    const rate =
      Number(localOpsMeta.jgkPerUsd) > 0 ? localOpsMeta.jgkPerUsd : 1000;
    const firstFinite = (values) => {
      for (const value of values) {
        const parsed = parseNumber(value);
        if (parsed !== null) return parsed;
      }
      return null;
    };
    const firstPositive = (values) => {
      for (const value of values) {
        const parsed = parseNumber(value);
        if (parsed !== null && parsed > 0) return parsed;
      }
      return null;
    };
    const usdCandidates = isTask
      ? [
          localOpsMeta.priceUsd,
          localOpsMeta.task?.priceUsd,
          localOpsMeta.task?.price,
          localOpsMeta.task?.amount,
        ]
      : [
          localOpsMeta.priceUsd,
          localOpsMeta.offering?.priceUsd,
          localOpsMeta.offering?.price,
        ];
    const jgkCandidates = isTask
      ? [
          localOpsMeta.priceJGK,
          localOpsMeta.task?.priceJGK,
          localOpsMeta.task?.escrowAmountJGK,
          localOpsMeta.task?.requiredJGK,
          localOpsMeta.task?.requiredJgk,
          localOpsMeta.escrowAmountJGK,
          localOpsMeta.requiredJGK,
        ]
      : [
          localOpsMeta.priceJGK,
          localOpsMeta.offering?.priceJGK,
          localOpsMeta.offering?.requiredJGK,
        ];
    const positiveJgk = firstPositive(jgkCandidates);
    const priceUsd = isTask
      ? firstPositive(usdCandidates)
      : firstPositive(usdCandidates) ??
        (positiveJgk !== null ? null : firstFinite(usdCandidates));
    const priceJgk = isTask
      ? positiveJgk ?? (priceUsd !== null ? priceUsd * rate : null)
      : positiveJgk ??
        firstFinite(jgkCandidates) ??
        (priceUsd !== null ? priceUsd * rate : null);
    const usdFromJgk =
      priceUsd === null && priceJgk !== null ? priceJgk / rate : priceUsd;
    const finalPriceUsd = usdFromJgk;
    const formatUsdLabel = (value) =>
      value === null ? null : `$${Number(value).toFixed(2)}`;
    const formatJgkLabel = (value) =>
      value === null ? null : `${Math.round(value).toLocaleString()} JGK`;
    const offeringStatus = String(
      localOpsMeta.offering?.reservationStatus ||
        localOpsMeta.offering?.status ||
        localOpsMeta.status ||
        '',
    ).toLowerCase();
    const offeringIsReserved =
      localOpsMeta.offering?.isReserved === true ||
      localOpsMeta.offering?.order?.escrowStatus === 'held' ||
      localOpsMeta.escrowStatus === 'held' ||
      ['reserved', 'in_progress', 'in-progress', 'active_reserved'].includes(
        offeringStatus,
      );
    const showEscrow = isTask || offeringIsReserved;
    const usdLabel = formatUsdLabel(finalPriceUsd);
    return {
      priceLine: usdLabel
        ? `${isTask ? 'Paid today' : 'Price'}: ${usdLabel}`
        : null,
      escrowLine:
        showEscrow && priceJgk !== null
          ? `(${formatJgkLabel(priceJgk)} escrowed)`
          : null,
    };
  }, [localOpsCommunityTask, localOpsMeta]);

  const resolveShareUrl = useCallback(() => {
    const target = localOpsLink?.share || '';
    if (!target) return '';
    // Absolute URL provided by backend
    if (/^https?:\/\//i.test(target)) return target;
    // Relative share path like /share/task/:id
    if (target.startsWith('/share/')) {
      const parts = target.split('/');
      const type = parts[2];
      const id = parts[3];
      if (type && id) return getShareUrl(type, id);
    }
    // Fallback: derive from entityType + post id if possible
    const type =
      localOpsMeta?.entityType === 'offering'
        ? 'offering'
        : localOpsMeta?.entityType || 'task';
    const id =
      localOpsMeta?.task?.id ||
      localOpsMeta?.task?._id ||
      localOpsMeta?.offering?.id ||
      localOpsMeta?.offering?._id ||
      null;
    if (type && id) return getShareUrl(type, id);
    return target;
  }, [localOpsLink?.share, localOpsMeta]);
  const locationChip = useMemo(() => {
    const viewerLat = currentPlayer?.data?.player?.lastLocation?.coordinates
      ? currentPlayer.data.player.lastLocation.coordinates[1]
      : null;
    const viewerLon = currentPlayer?.data?.player?.lastLocation?.coordinates
      ? currentPlayer.data.player.lastLocation.coordinates[0]
      : null;
    return buildLocationChip({
      post,
      viewerLat,
      viewerLon,
    });
  }, [post, currentPlayer]);
  const contextLabel = post?.contextLabel || '';
  const localOpsIsOwner = useMemo(() => {
    if (!localOpsMeta) return false;
    const ownerHandle =
      localOpsMeta?.owner?.playerId ||
      (!isShareLanding ? post?.playerId || post?.author?.playerId : null) ||
      null;
    const ownerId =
      localOpsMeta?.owner?._id ||
      post?.userId?._id ||
      post?.creator?._id ||
      post?.author?._id ||
      null;
    const viewerHandle = currentPlayerId;
    const viewerId = currentPlayerDbId;
    return (
      (ownerHandle && viewerHandle && String(ownerHandle) === String(viewerHandle)) ||
      (ownerId && viewerId && String(ownerId) === String(viewerId))
    );
  }, [isShareLanding, localOpsMeta, post, currentPlayerId, currentPlayerDbId]);
  const authorFromPost = useMemo(() => resolvePostAuthor(post), [post]);
  const [anchorEl, setAnchorEl] = useState(null);
  //const [isCloud, setIsCloud] = useState(false);
  const [commentCount, setCommentCount] = useState(1);
  const [comments, setComments] = useState(post?.comments || []);
  const commentCountRef = useRef(1);

  const [likePlayer, setLikePlayer] = useState({});
  const [likeProfileImgs, setlikeProfileImgs] = useState([]);
  const [messageTextIsVideo, setMessageTextIsVideo] = useState(false);
  const [jgkOnPost, setJGKOnPost] = useState(false);
  const [jgkTokens, setJgkTokens] = useState(post?.jgkTokens || 0);
  const [isLoading, setIsLoading] = useState(false);
  const [sendJGKToPostAmount, setSendJGKToPostAmount] = useState(0);
  const [myFriends, SetMyFriends] = useState([]);
  const [myFriendsToSharePost, SetMyFriendsToSharePost] = useState([]);
  const handleLocalOpsNavigate = useCallback(() => {
    if (!localOpsLink) return;
    onLocalOpsPrimaryCta?.();
    if (isShareLanding && localOpsLink.continue) {
      window.location.href = localOpsLink.continue;
      return;
    }
    if (localOpsLink.map) {
      const detail = {
        type: localOpsLink.map.type,
        id: localOpsLink.map.id,
      };
      window.dispatchEvent(new CustomEvent('localops:navigate', { detail }));
      const targetUrl = `/playermap?type=${detail.type}&id=${detail.id}`;
      if (window.location.pathname !== '/playermap') {
        window.location.href = targetUrl;
      }
    } else if (localOpsLink.share) {
      window.location.href = localOpsLink.share;
    } else if (localOpsLink.continue) {
      window.location.href = localOpsLink.continue;
    }
  }, [isShareLanding, localOpsLink, onLocalOpsPrimaryCta]);

  const { socket: socket2 } = useContext(SocketContext);
  const [onlinePlayers, setOnlinePlayers] = useState([]);
  const [currentChat, setCurrentChat] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [repostTrigger, setRepostTrigger] = useState(false); // State variable to track reposts

  // let subtitle;
  const [modal, setModal] = useState(false);
  const [isShare, setIsShare] = useState(false);
  const [isRepost, setIsRepost] = useState(false);
  const [dialogIsSupported, setDialogIsSupported] = useState(false);
  const imgRef = useRef(null);
  const [textPosition, setTextPosition] = useState({ top: '0px', left: '0px' });
  const [isSoundPlaying, setIsSoundPlaying] = useState(false);
  const [showText, setShowText] = useState(false);
  const [liveViewers, setLiveViewers] = useState(0);
  const [commentTypingHint, setCommentTypingHint] = useState('');
  const typingTimeoutRef = useRef(null);

  useEffect(() => {
    if (!authorFromPost) return;
    // Keep previously known identity/photo when live updates omit hydrated author fields.
    setPlayer((prev = {}) => ({
      ...prev,
      ...authorFromPost,
      playerId: authorFromPost.playerId || prev.playerId || null,
      profilePhoto: authorFromPost.profilePhoto || prev.profilePhoto || null,
      _id: authorFromPost._id || prev._id || null,
    }));
  }, [authorFromPost]);

  useEffect(() => {
    setJgkd(post?.jgkd?.length || 0);
    setJgkTokens(post?.jgkTokens || 0);
  }, [post?.jgkd, post?.jgkTokens]);

  const MyOptions = canEditPost ? ['Edit Post', 'Delete Post'] : ['Delete Post'];
  const mobileView = useMediaQuery({
    query: '(max-width: 805px)',
  });
  const { width } = useContext(ViewPortContext);
  const numOfImages = width <= 280 ? 4 : 6;

  const handleReact = async (type) => {
    await axiosConn.put(
      `posts/${post._id}/react`,
      {
        playerId: currentPlayer.data.player.playerId,
        type,
        profilePhoto: currentPlayer.data.player.profilePhoto,
      },
      {
        headers: { Authorization: `Bearer ${currentPlayer.token}` },
      },
    );
    // Fetch updated post and update state
    const res = await axiosConn.get(`posts/${post._id}`, {
      headers: { Authorization: `Bearer ${currentPlayer.token}` },
    });
    // console.log('Post after reaction:', res.data.data.data);
    setPost(res.data.data.data);
    socket2.emit('updatePost', { updatedPost: res.data.data.data });
  };

  const { darkTheme: ctxDarkTheme } = useTheme();
  const darkTheme = isShareLanding ? true : ctxDarkTheme;
  const classes = useStyles({ darkTheme }) || {};

  const closePostMenu = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    // console.log(event.currentTarget);
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);

  const handleDeletePost = async () => {
    // console.log(post?.desc);
    // console.log(currentPlayer);
    // Emit the deletePost event to the server
    socket2.emit('deletePost', { post: initialPost });

    try {
      //const res =
      await axiosConn.delete(`posts/${post._id}`, {
        headers: {
          Authorization: `Bearer ${currentPlayer.token}`,
        },
        data: {
          playerId: currentPlayer.data.player.playerId,
        },
      });
      onDelete(initialPost._id);
      //console.log(res.data);
    } catch (err) {
      console.log(err);
    }
    // window.location.reload();
  };

  const handleStartPostEdit = () => {
    if (!canEditPost) return;
    revokePostEditDraftPreviews(editMediaDraftRef.current);
    setEditDesc(post?.desc || '');
    setEditMediaDraft(makePostEditMediaDraft(post));
    setEditUploadProgress(0);
    setEditError('');
    setIsEditingPost(true);
  };

  const handleMenuOptionClick = (event, option) => {
    event.preventDefault();
    event.stopPropagation();
    if (option === 'Edit Post') {
      handleStartPostEdit();
      closePostMenu();
      return;
    }
    handleDeletePost();
    closePostMenu();
  };

  const handleCancelPostEdit = () => {
    revokePostEditDraftPreviews(editMediaDraftRef.current);
    setIsEditingPost(false);
    setEditDesc(post?.desc || '');
    setEditMediaDraft(makePostEditMediaDraft(post));
    setEditUploadProgress(0);
    setEditError('');
  };

  const handlePickPostEditMedia = () => {
    if (isSavingEdit) return;
    editFileInputRef.current?.click();
  };

  const handlePostEditFileInput = async (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (!selectedFiles.length) return;

    const staged = [];
    const errors = [];
    const editUploader = await getPostEditUploader();

    selectedFiles.forEach((file) => {
      try {
        editUploader.validate(file);
        staged.push({
          id: `new-${Date.now()}-${file.name}-${Math.random()}`,
          persisted: false,
          file,
          preview: URL.createObjectURL(file),
          type: isVideoFile(file.name) ? 'video' : 'image',
          size: file.size || 0,
        });
      } catch (err) {
        errors.push(err.message || `${file.name} is not valid.`);
      }
    });

    if (editFileInputRef.current) {
      editFileInputRef.current.value = '';
    }

    if (errors.length) {
      setEditError(errors.join(' | '));
    } else {
      setEditError('');
    }

    if (!staged.length) return;

    const slotsLeft = Math.max(0, POST_EDIT_MAX_MEDIA - editMediaDraft.length);
    const accepted = staged.slice(0, slotsLeft);
    staged.slice(slotsLeft).forEach((item) =>
      revokePostEditDraftPreviews([item]),
    );
    if (accepted.length < staged.length) {
      setEditError(`Posts can have up to ${POST_EDIT_MAX_MEDIA} media items.`);
    }
    setEditMediaDraft((prev) => [...prev, ...accepted]);
  };

  const handleRemovePostEditMedia = (index) => {
    if (isSavingEdit) return;
    setEditMediaDraft((prev) => {
      const removed = prev[index];
      revokePostEditDraftPreviews([removed]);
      return prev.filter((_, itemIndex) => itemIndex !== index);
    });
    if (editError) setEditError('');
  };

  const handleSetPostEditCover = (index) => {
    if (isSavingEdit || index <= 0) return;
    setEditMediaDraft((prev) => {
      const next = [...prev];
      const [selected] = next.splice(index, 1);
      return selected ? [selected, ...next] : prev;
    });
    if (editError) setEditError('');
  };

  const handleSavePostEdit = async (event) => {
    event.preventDefault();
    if (!canSavePostEdit) return;

    setIsSavingEdit(true);
    setEditError('');
    setEditUploadProgress(0);

    try {
      const nextMedia = [];
      const uploadItems = editMediaDraft.filter((item) => item.file);
      let uploadedCount = 0;

      for (const item of editMediaDraft) {
        if (item.file) {
          const editUploader = await getPostEditUploader();
          editUploader.validate(item.file);
          const uploadResult = await editUploader.upload(item.file, {
            publicIdPrefix: 'Images',
            onProgress: (percent) => {
              const completed = uploadedCount * 100;
              const total = Math.max(1, uploadItems.length * 100);
              setEditUploadProgress(
                Math.min(100, Math.round(((completed + percent) / total) * 100)),
              );
            },
          });
          uploadedCount += 1;
          const url = uploadResult?.transformedUrl || uploadResult?.secureUrl;
          if (!url || isBlockedPostEditMediaUrl(url)) {
            throw new Error('Uploaded media URL was not valid.');
          }
          nextMedia.push({
            url,
            type: item.type || (isVideoFile(url) ? 'video' : 'image'),
            width: toFinitePostEditNumber(uploadResult?.imageMeta?.width),
            height: toFinitePostEditNumber(uploadResult?.imageMeta?.height),
            duration: toFinitePostEditNumber(uploadResult?.videoMeta?.duration),
            size: toFinitePostEditNumber(item.file?.size),
          });
          continue;
        }

        if (!item.url || isBlockedPostEditMediaUrl(item.url)) {
          throw new Error('One media item is not a stable uploaded file.');
        }
        nextMedia.push(toPostEditMediaPayload(item));
      }

      const requestBody = { desc: editDesc };
      if (isEditMediaChanged) {
        requestBody.media = nextMedia;
      }

      const res = await axiosConn.patch(
        `posts/${post._id}`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      );
      const updatedPost = res?.data?.data?.data;
      if (!updatedPost?._id) {
        throw new Error('Unexpected post edit response');
      }
      revokePostEditDraftPreviews(editMediaDraftRef.current);
      setPost(updatedPost);
      onUpdate(updatedPost);
      setEditMediaDraft(makePostEditMediaDraft(updatedPost));
      setEditUploadProgress(0);
      setIsEditingPost(false);
    } catch (err) {
      setEditError(
        err?.response?.data?.message ||
          err?.message ||
          'Could not save post edit.',
      );
    } finally {
      setIsSavingEdit(false);
    }
  };

  
  useEffect(() => {
    let mounted = true;
    //This grabs logged on player's friends.
    if (isShareLanding || !loggedInPlayer?.token || !loggedInPlayer?.data?.player?._id) {
      return () => {
        mounted = false;
      };
    }
    const getMyFriends = async () => {
      try {
        const friendList = await axiosConn.get(
          'players/friends/' + loggedInPlayer.data.player._id,
          {
            headers: {
              Authorization: `Bearer ${loggedInPlayer.token}`,
            },
          },
        );
        if (!mounted) return;
        const safeFriends = Array.isArray(friendList.data)
          ? friendList.data.filter((f) => f && f._id)
          : [];
        if (safeFriends.length !== (friendList.data?.length || 0)) {
          console.warn('[Post] filtered stale/null friends', {
            requested: friendList.data?.length || 0,
            kept: safeFriends.length,
          });
        }
        SetMyFriends(safeFriends);
      } catch (err) {
        console.warn('[Post] failed to load friends', err?.message || err);
        if (!mounted) return;
        SetMyFriends([]);
      }
    };
    getMyFriends();
    return () => {
      mounted = false;
    };
  }, [isShareLanding, loggedInPlayer.token, loggedInPlayer.data.player._id]);

  useEffect(() => {
    isEditingPostRef.current = isEditingPost;
  }, [isEditingPost]);

  useEffect(() => {
    editMediaDraftRef.current = editMediaDraft;
  }, [editMediaDraft]);

  useEffect(
    () => () => {
      revokePostEditDraftPreviews(editMediaDraftRef.current);
    },
    [],
  );

  useEffect(() => {
    const incomingPostId = getPostRealtimeId(initialPost);
    const previousPostId = previousPostIdRef.current;
    const postIdChanged =
      Boolean(incomingPostId || previousPostId) &&
      incomingPostId !== previousPostId;

    previousPostIdRef.current = incomingPostId;
    setPost(initialPost);

    if (postIdChanged) {
      revokePostEditDraftPreviews(editMediaDraftRef.current);
      setIsEditingPost(false);
      setEditDesc(initialPost?.desc || '');
      setEditMediaDraft(makePostEditMediaDraft(initialPost));
      setEditUploadProgress(0);
      setEditError('');
    } else if (!isEditingPostRef.current) {
      revokePostEditDraftPreviews(editMediaDraftRef.current);
      setEditDesc(initialPost?.desc || '');
      setEditMediaDraft(makePostEditMediaDraft(initialPost));
      setEditUploadProgress(0);
      setEditError('');
    }

    setLike(initialPost?.likes?.length || 0);
    setComments(initialPost?.comments || []);
    setCommentCount(initialPost?.comments?.length || 0);
    setCommentCount(2); // Reset to initial number of comments to show
  }, [initialPost]);

  useEffect(() => {
    setLike(post?.likes?.length || 0);
    setIsLiked(currentPlayerHasLikedPost);
  }, [post?.likes, currentPlayerHasLikedPost]);

  const likeHandler = async () => {
    try {
      const action = isLiked ? 'unlike' : 'like';
      const response = await axiosConn.put(
        'posts/' + post._id + '/like',
        { action },
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      );

      const updatedPost = response.data?.data?.post;
      if (!updatedPost) {
        console.warn('[Post.likeHandler] Like response missing updated post');
        return;
      }

      setPost((prevPost) => mergeUntrustedPostUpdate(prevPost, updatedPost));
      setLike(updatedPost.likes?.length || 0);
      setIsLiked(hasPlayerLiked(updatedPost.likes, currentPlayerId));

      // Emit the updated post to the server
      socket2.emit('updatePost', { updatedPost });
    } catch (err) {
      console.error(err);
    }
  };

  const rePostHandler = async () => {
    //console.log(currentPlayer);
    // console.log('rePostHander Top');
    try {
      const res = await axiosConn.put(
        'posts/' + post._id + '/repost',
        {
          playerId: currentPlayer.data.player.playerId,
        },
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      );
      // console.log(res.data.data.post);

      socket2.emit('sendPost', { post: res.data.data.post });
    } catch (err) {}
    setShare((prev) => prev + 1);
    // setIsLiked(!isLiked);
  };
  const shareHandler = async () => {
    //console.log(currentPlayer);
    // console.log('shareHander Top');
    try {
      const res = await axiosConn.put(
        'posts/' + post._id + '/reshare',
        {
          playerId: currentPlayer.data.player.playerId,
        },
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      );
      // console.log(res.data);
      if (!res.data.includes('The post has already been reShared')) {
        setShare((prev) => prev + 1);
      }
    } catch (err) {}
    // setIsLiked(!isLiked);
  };

  const showMore = () => {
    setCommentCount((prev) => prev + 3);
    commentCountRef.current += 3; // Show 3 more comments
  };

  const handleCommentDeleted = useCallback((commentId, nextComments) => {
    setComments((prevComments = []) => {
      const updatedComments = Array.isArray(nextComments)
        ? nextComments
        : removeCommentById(prevComments, commentId);
      const nextVisibleCount = Math.min(
        Math.max(commentCountRef.current, 1),
        Math.max(updatedComments.length, 1),
      );
      commentCountRef.current = nextVisibleCount;
      setCommentCount(updatedComments.length);
      return updatedComments;
    });
  }, []);

  useEffect(() => {
    if (isShareLanding || !post || typeof post !== 'object') {
      return null;
    }
    if (!currentPlayer?.token || !post?._id) {
      return null;
    }
    //setting views
    axiosConn
      .put(
        'posts/' + post._id + '/view',
        {},
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      )
      .catch((err) => {
        console.error(
          'View update failed',
          err?.response?.data || err.message || err,
        );
      });
    //console.log(post);
    setViews((view) => view + 1);
    return () => {};
  }, [isShareLanding, currentPlayer?.token, post?._id]);

  // console.log(post);
  const handleClickJGKOnPostToggle = (event) => {
    // console.log('handleClickJGKOnPostToggle', jgkOnPost);
    jgkOnPost === false ? setJGKOnPost(true) : setJGKOnPost(false);
  };

  const handleSendJGKToPostAmount = async (e) => {
    // console.log('handleSendJGKToPostAmount');
    if (isSoundPlaying) return; // Prevent function from running if sound is playing

    // console.log(e.target.value);
    if (e.key === 'Enter' || e.type === 'click') {
      //send JGK.
      setIsLoading(true);

      // console.log(myFriends);
      // Debug: inspect playerId matching vs friends list
      console.log('[JGK][send] post.playerId', post?.playerId);
      console.log('[JGK][send] myFriends length', myFriends?.length || 0);
      const postPlayerId = myFriends.filter(
        (f) => post?.playerId === f.playerId,
      );
      console.log('[JGK][send] postPlayerId matches', postPlayerId);

      let receiver;
      if (post.galaxyId) {
        receiver = post.playerId;
      } else {
        if (postPlayerId.length === 0) {
          // Handle the case where post.playerId is not in myFriends
          setIsLoading(false);
          console.warn('[JGK][send] receiver not found in myFriends');
          return;
        }
        receiver = postPlayerId[0]._id;
      }
      // console.log(
      //   postPlayerId[0]._id,
      //   loggedInPlayer.data.player._id,
      //   sendJGKToPostAmount,
      // );

      if (sendJGKToPostAmount > loggedInPlayer.data.player.jgkTokens) {
        //setError
        return;
      }

      try {
        // console.log('sender: ', loggedInPlayer.data.player._id);
        // console.log('receiver: ', postPlayerId[0]._id);
        // console.log('receivingPostId: ', post._id);
        // console.log(`text: POGW:${post?.playerId}:${post?.desc}: ${post?._id}`);
        // console.log(receiver);
        const res = await axiosConn.post(
          'jgkTokenTransactions/sendJGKToPostPOGW/',
          {
            receiver: receiver,
            receivingPostId: post._id,
            sender: loggedInPlayer.data.player._id,
            amount: sendJGKToPostAmount,
            text: `POGW:${post?.playerId}:${post?.desc}: ${post?._id}`,
          },
          {
            headers: {
              Authorization: `Bearer ${loggedInPlayer.token}`,
            },
          },
        );
        // window.location.href = res2.data.session.url;
        // console.log(res.data.post);
        // playSound
        setIsLoading(false);
        setJGKOnPost(false);
        setIsSoundPlaying(true); // Indicate that sound is about to play
        try {
          await playSound(winningSound);
        } catch (audioErr) {
          // swallow audio errors to avoid breaking flow
          console.warn('JGK audio failed to play', audioErr);
        } finally {
          setIsSoundPlaying(false); // Reset after sound has played
        }

        setPost(res.data.post);

        // Emit the updated post to the server
        socket2.emit('updatePost', { updatedPost: res.data.post });
      } catch (err) {
        setIsLoading(false);

        console.log(err);
      }
    }
  };

  useEffect(() => {
    if (isShareLanding || !modal) {
      return undefined;
    }
    if (!loggedInPlayer?.data?.player?.friends) {
      return undefined;
    }
    if (!socket2) {
      return undefined;
    }
    if (!loggedInPlayer?.data?.player?.friends) {
      return undefined;
    }
    if (isShareLanding) {
      return undefined;
    }
    if (modal) {
      // console.log('modal');
      socket2.on('getPlayers', (players) => {
        setOnlinePlayers(
          loggedInPlayer.data.player.friends.filter((f) =>
            players.some((u) => u.playerId === f),
          ),
        );
      });
    }
    return () => {
      // before the component is destroyed
      // unbind all event handlers used in this component
      socket2.off('getPlayers');
    };
  }, [isShareLanding, loggedInPlayer.data.player.friends, modal, socket2]);

  // Live post updates (comments, reactions, views, typing, live viewers)
  useEffect(() => {
    if (isShareLanding) return undefined;
    if (!socket2 || !post?._id) return undefined;

    const handleCommentsUpdate = ({ postId, comments: incoming }) => {
      if (String(postId || '') !== String(post._id || '')) return;
      const nextComments = incoming || [];
      setComments(nextComments);
      setCommentCount(nextComments.length || 0);
      if (nextComments.length > commentCountRef.current) {
        commentCountRef.current = nextComments.length;
      }
    };

    const handleCommentDeletedUpdate = ({
      postId,
      commentId,
      comments: incoming,
    }) => {
      if (String(postId || '') !== String(post._id || '')) return;
      handleCommentDeleted(commentId, incoming);
    };

    const handleTyping = ({ postId, playerId }) => {
      if (String(postId || '') !== String(post._id || '')) return;
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
      setCommentTypingHint(
        playerId ? `${playerId} is typing...` : 'Someone is typing...',
      );
      typingTimeoutRef.current = setTimeout(() => {
        setCommentTypingHint('');
      }, 5000);
    };

    const handleLiveViewers = ({ postId, count }) => {
      if (String(postId || '') !== String(post._id || '')) return;
      setLiveViewers(typeof count === 'number' ? Math.max(0, count) : 0);
    };

    const handleReactions = ({ postId, likes: likeArr, reactions }) => {
      if (String(postId || '') !== String(post._id || '')) return;
      if (Array.isArray(likeArr)) {
        setLike(likeArr.length);
        setPost((prev) => ({ ...prev, likes: likeArr }));
      }
      if (reactions) {
        setPost((prev) => ({ ...prev, reactions }));
      }
    };

    const handleViews = ({ postId, views: incomingViews }) => {
      if (String(postId || '') !== String(post._id || '')) return;
      if (typeof incomingViews === 'number')
        setViews(Math.max(0, incomingViews));
    };

    socket2.on('getPostCommentsUpdates', handleCommentsUpdate);
    socket2.on('post:comment:deleted', handleCommentDeletedUpdate);
    socket2.on('post:comment:typing', handleTyping);
    socket2.on('post:liveViewers', handleLiveViewers);
    socket2.on('post:reaction', handleReactions);
    socket2.on('post:view', handleViews);
    const handlePostUpdate = (event) => {
      const updatedPost = event?.updatedPost || event;
      if (!updatedPost?._id || String(updatedPost._id) !== String(post._id)) {
        return;
      }
      setPost((prevPost) => mergeUntrustedPostUpdate(prevPost, updatedPost));
    };
    const handlePostEdited = (payload) => {
      setPost((prevPost) => applyPostEditToPost(prevPost, payload));
    };
    socket2.on('updatePost', handlePostUpdate);
    socket2.on('getPostUpdates', handlePostUpdate);
    socket2.on('post:edited', handlePostEdited);

    return () => {
      socket2.off('getPostCommentsUpdates', handleCommentsUpdate);
      socket2.off('post:comment:deleted', handleCommentDeletedUpdate);
      socket2.off('post:comment:typing', handleTyping);
      socket2.off('post:liveViewers', handleLiveViewers);
      socket2.off('post:reaction', handleReactions);
      socket2.off('post:view', handleViews);
      socket2.off('updatePost', handlePostUpdate);
      socket2.off('getPostUpdates', handlePostUpdate);
      socket2.off('post:edited', handlePostEdited);
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    };
  }, [handleCommentDeleted, isShareLanding, post?._id, socket2]);

  const sharePostToMessenger = async (receiverPlayer, senderPlayer) => {
    // console.log(receiverPlayer, senderPlayer);
    if (receiverPlayer?._id && senderPlayer?._id) {
      try {
        const res = await axiosConn
          .get(
            `conversations/find/${receiverPlayer._id}/${senderPlayer._id}`,
            {
              headers: {
                Authorization: `Bearer ${loggedInPlayer.token}`,
              },
            },
          )
          .then(async (res) => {
            if (res.data === null) {
              // console.log('No conversation yet. creating...');
              try {
                //create new conversation.
                const res = await axiosConn.post(
                  `conversations/`,
                  {
                    senderId: loggedInPlayer.data.player._id,
                    receiverId: receiverPlayer._id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${loggedInPlayer.token}`,
                    },
                  },
                );

                // console.log(res.data);
                setCurrentChat(res.data);
                // console.log(
                //   'sending...to new conversation..conversationId: ',
                //   res.data._id,
                // );
                let message = {
                  sender: loggedInPlayer.data.player._id,
                  text: `sharedPost by ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                  img: post.img,
                  conversationId: res.data._id,
                  // isRead: false,
                  isRead: onlinePlayers?.includes(receiverPlayer._id)
                    ? true
                    : false,
                };
                // console.log(message);
                //send to socket
                try {
                  socket2.emit('sendMessage', {
                    senderId: loggedInPlayer.data.player._id,
                    senderPlayerId: loggedInPlayer.data.player.playerId,
                    receiverId: receiverPlayer._id,
                    text: `sharedPost by ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                    img: post.img,
                  });
                  // checkPageStatus(text, player.data.player._id);
                } catch (err) {
                  console.log(err);
                }

                // console.log(onlinePlayers.includes(receiverId) ? 'true' : 'false');
                try {
                  setLoading(true);
                  //send to messages table
                  const res = await axiosConn.post(
                    `messages/${
                      onlinePlayers.includes(receiverPlayer._id)
                        ? 'true'
                        : 'false'
                    }`,
                    message,
                    {
                      headers: {
                        Authorization: `Bearer ${loggedInPlayer.token}`,
                      },
                    },
                  );
                  // console.log(res.data.data.data);
                  // console.log(...messages);
                  setLoading(false);
                } catch (err) {
                  setLoading(false);
                  console.log(err);
                }
              } catch (err) {
                console.log(err);
              }
            } else {
              //existing conversation.
              // console.log(
              //   'sending to existing conversation...conversationId: ',
              //   res.data._id,
              // );
              let message = {
                sender: loggedInPlayer.data.player._id,
                text: `sharedPost by ${post.playerId}: ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                img: post.img,
                conversationId: res.data._id,
                // isRead: false,
                isRead: onlinePlayers?.includes(receiverPlayer._id)
                  ? true
                  : false,
              };
              // console.log(message);
              //send to sockedt
              try {
                socket2.emit('sendMessage', {
                  senderId: loggedInPlayer.data.player._id,
                  senderPlayerId: loggedInPlayer.data.player.playerId,
                  receiverId: receiverPlayer._id,
                  text: `sharedPost by ${post.playerId}: ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                  img: post.img,
                });
                // checkPageStatus(text, player.data.player._id);
              } catch (err) {
                console.log(err);
              }

              // console.log(onlinePlayers.includes(receiverId) ? 'true' : 'false');
              try {
                setLoading(true);
                //send to messages
                const res = await axiosConn.post(
                  `messages/${
                    onlinePlayers.includes(receiverPlayer._id)
                      ? 'true'
                      : 'false'
                  }`,
                  message,
                  {
                    headers: {
                      Authorization: `Bearer ${loggedInPlayer.token}`,
                    },
                  },
                );
                // console.log(res.data.data.data);
                // console.log(...messages);
                setLoading(false);
              } catch (err) {
                setLoading(false);
                console.log(err);
              }
            }
          });
      } catch (err) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    setDialogIsSupported(checkHtmlDialogElement());
  }, []);

  const handleSharePost = () => {
    setIsLoading(true);

    // console.log('handleSharePost Top');
    // console.log(myFriendsToSharePost);
    myFriendsToSharePost.forEach((friend) => {
      sharePostToMessenger(friend, loggedInPlayer.data.player);
      // sharePostToMessenger(post, friend);
    });
    shareHandler(); //add playerId to reShares on Post.

    setIsLoading(false);
    setModal(false);
  };

  const handleRepost = () => {
    setIsLoading(true);
    // console.log('handleRepost');
    rePostHandler();
    setModal(false);

    setIsLoading(false);
    // window.location.reload();
  };

  const handleIsShareClicked = () => {
    // console.log('handleIsShareClicked');
    setIsShare((prev) => !prev);
  };

  const handleIsRepostClicked = () => {
    // console.log('handleIsRepost');
    setIsRepost((prev) => !prev);
  };

  // Join/leave post room for live viewers/events
  useEffect(() => {
    if (isShareLanding) return undefined;
    if (!socket2 || !post?._id) return undefined;
    const payload = { postId: post._id };
    socket2.emit('post:join', payload);
    return () => {
      socket2.emit('post:leave', payload);
    };
  }, [isShareLanding, post?._id, socket2]);

  const sortedComments = useMemo(() => {
    if (!comments || comments.length === 0) return [];
    return [...comments].sort((a, b) => {
      return new Date(b.commentAt) - new Date(a.commentAt);
    });
  }, [comments]);

  // if (!post || typeof post !== 'object') {
  //   return null;
  // }
  // console.log(post);
  const resolvedPostAvatar = resolvePostProfilePhoto(
    player?.profilePhoto,
    post?.author?.profilePhoto,
    post?.author?.profilePicture,
    post?.author?.avatar,
    post?.profilePhoto,
    post?.profilePicture,
    post?.avatar,
    post?.user?.profilePhoto,
    post?.user?.profilePicture,
    post?.user?.avatar,
    post?.creator?.profilePhoto,
    post?.creator?.profilePicture,
    post?.creator?.avatar,
    post?.userId?.profilePhoto,
    post?.userId?.profilePicture,
    post?.userId?.avatar,
  );
  const hasShareLandingMedia = Boolean(
    Array.isArray(post?.media)
      ? post.media.length
      : post?.img || post?.coverMedia,
  );
  const localOpsKindLabel = localOpsMeta?.entityType === 'offering'
    ? 'Offering'
    : localOpsCommunityTask
    ? 'Community Task'
    : 'Task';
  const localOpsTitle =
    post?.title ||
    post?.desc ||
    localOpsMeta?.task?.title ||
    localOpsMeta?.offering?.title ||
    'LocalOps';
  const localOpsRegion =
    locationChip || localOpsMeta?.regionLabel || contextLabel || 'Nearby';
  const localOpsCompactPrice = paymentDisplay.priceLine
    ? paymentDisplay.priceLine.replace(/^(Paid today|Price):\s*/i, '')
    : localOpsCommunityTask
    ? 'Action Credit'
    : localOpsMeta?.offering?.requestQuote
    ? 'Quote'
    : '';
  const localOpsStatusLabel = localOpsCommunityTask
    ? 'No cash payout'
    : localOpsMeta?.offering?.requestQuote
    ? 'Quote required'
    : localOpsMeta?.escrowStatus === 'held'
    ? 'Funded'
    : localOpsMeta?.priceUsd
    ? 'Payment ready'
    : '';
  const localOpsHeroClassName = [
    'localops-hero-card',
    localOpsPresentation === 'feedExpanded'
      ? 'localops-hero-card--feed-expanded'
      : '',
    localOpsPresentation === 'localOpsMode'
      ? 'localops-hero-card--localops-mode'
      : '',
  ]
    .filter(Boolean)
    .join(' ');

  if (isShareLanding && localOpsMeta) {
    return (
      <div className={darkTheme ? 'postDarkTheme' : 'post'}>
        <div className="postWrapper">
          <div className="localops-hero-card">
            <div className="localops-hero-header">
              <div className="localops-signature">
                <JGLocalOpsMark />
              </div>
              <div className="localops-hero-pills">
                <span className="localops-pill-chip">
                  {localOpsMeta.entityType === 'offering'
                    ? 'Offering'
                    : localOpsCommunityTask
                    ? 'Community Task'
                    : 'Task'}
                </span>
                <span className="localops-pill-chip localops-pill-chip--ready">
                  {localOpsCommunityTask
                    ? 'No cash payout'
                    : localOpsMeta.entityType === 'offering'
                    ? 'Payment Ready'
                    : 'Funded'}
                </span>
              </div>
              <div className="localops-hero-region">
                {locationChip || localOpsMeta.regionLabel || contextLabel || 'Nearby'}
              </div>
            </div>
            <div className="localops-hero-body">
              <div className="localops-hero-avatar">
                {player?.profilePhoto ||
                localOpsMeta?.owner?.profilePhoto ||
                post?.profilePhoto ? (
                  <img
                    src={
                      player?.profilePhoto ||
                      localOpsMeta?.owner?.profilePhoto ||
                      post?.profilePhoto
                    }
                    alt={localOpsOwnerDisplay}
                  />
                ) : (
                  <span className="localops-avatar__fallback">
                    {localOpsOwnerDisplay.charAt(0)}
                  </span>
                )}
              </div>
              <div className="localops-hero-text">
                {localOpsOwnerProfileTarget ? (
                  <Link
                    className="localops-hero-owner localops-hero-owner-link"
                    to={localOpsOwnerProfileTarget}
                  >
                    {localOpsOwnerDisplay}
                  </Link>
                ) : (
                  <div className="localops-hero-owner">{localOpsOwnerDisplay}</div>
                )}
                <div className="localops-hero-title">
                  {post.title ||
                    post.desc ||
                    localOpsMeta?.task?.title ||
                    localOpsMeta?.offering?.title ||
                    'LocalOps'}
                </div>
                {paymentDisplay.priceLine ? (
                  <div className="localops-hero-price">
                    {paymentDisplay.priceLine}
                    {paymentDisplay.escrowLine ? (
                      <span className="localops-hero-price-sub">
                        {paymentDisplay.escrowLine}
                      </span>
                    ) : null}
                  </div>
                ) : null}
                {actionableCommunityShareLanding ? (
                  <>
                    <div className="localops-hero-price">
                      No cash payout • Earn 1 Action Credit after verified completion
                    </div>
                    <div className="localops-helper">
                      Help your community and build a reputation for showing up.
                    </div>
                  </>
                ) : null}
              </div>
            </div>
            {hasShareLandingMedia ? (
              <div
                className="localops-share-landing-media"
                data-testid="localops-share-landing-media"
              >
                <PostMediaCarousel
                  item={post}
                  autoPlay={false}
                  enableZoom={true}
                  maxHeight="62vh"
                />
              </div>
            ) : null}
            <div className="localops-hero-actions">
              <button
                type="button"
                className="localops-hero-btn"
                onClick={handleLocalOpsNavigate}
              >
                {primaryCtaOverride ||
                  (localOpsMeta.entityType === 'offering' ? 'Reserve' : 'Accept')}
              </button>
              <div className="localops-hero-secondary">
                <button
                  type="button"
                  className="localops-hero-link"
                  onClick={handleLocalOpsNavigate}
                >
                  View on map
                </button>
                {!isShareLanding && localOpsLink?.share ? (
                  <button
                    type="button"
                    className="localops-hero-link"
                    onClick={() => (window.location.href = localOpsLink.share)}
                  >
                    Share
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (localOpsMeta && localOpsPresentation === 'feedCompact') {
    return (
      <div
        className={
          darkTheme ? 'postDarkTheme localops-feed-post' : 'post localops-feed-post'
        }
      >
        <div className="postWrapper localops-feed-postWrapper">
          <button
            type="button"
            className="localops-compact-row"
            aria-expanded={Boolean(localOpsExpanded)}
            onClick={onLocalOpsToggle || undefined}
          >
            <span className="localops-compact-kicker">{localOpsKindLabel}</span>
            <span className="localops-compact-main">
              <span className="localops-compact-title">{localOpsTitle}</span>
              <span className="localops-compact-meta">
                {localOpsRegion}
                {localOpsStatusLabel ? ` · ${localOpsStatusLabel}` : ''}
              </span>
            </span>
            {localOpsCompactPrice ? (
              <span className="localops-compact-price">{localOpsCompactPrice}</span>
            ) : null}
            <span className="localops-compact-chevron" aria-hidden="true">
              ›
            </span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Tooltip
        title={
          post?.isPogw && post.playerId !== currentPlayer?.data.player.playerId
            ? `Proof Of Great Work, consider rewarding JGK`
            : null
        }
      >
        <div
          className={
            post?.isPogw ? 'postPOGW' : darkTheme ? 'postDarkTheme' : 'post'
          }
          // onClick={handlePostClick}
        >
          <div className="postWrapper">
            <div className="postTop">
              <div className="postTopLeft">
                <Link to={`/profile/${player?.playerId}`}>
                  <img
                    className={
                      !mobileView ? 'postProfileImg' : 'postProfileImgMobile'
                    }
                    src={
                      resolvedPostAvatar
                        ? resolvedPostAvatar
                        : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                    }
                    alt=""
                    loading="lazy"
                  />
                </Link>
                <span
                  className={
                    !mobileView ? 'postPlayerId' : 'postPlayerIdMobile'
                  }
                >
                  {player.playerId}
                </span>
                <div className={!mobileView ? 'postViews' : 'postViewsMobile'}>
                  <VisibilityIcon sx={{ color: 'grey', fontSize: 15 }} />
                  {views}
                  {liveViewers > 0 && (
                    <span
                      style={{
                        marginLeft: 6,
                        fontSize: 11,
                        color: '#4caf50',
                        fontWeight: 600,
                      }}
                      title="Currently viewing"
                    >
                      • {liveViewers} live
                    </span>
                  )}
                </div>
                <span className={!mobileView ? 'postDate' : 'postDateMobile'}>
                  {preciseFormat(post?.createdAt)}
                </span>
                {post?.isPogw ? (
                  !mobileView ? (
                    <span className="pogwTitleSpan">Proof of Great Work</span>
                  ) : (
                    <span className="pogwTitleSpanMobile">POGW</span>
                  )
                ) : null}
              </div>
              <div
                className={`${
                  mobileView && post?.isPogw
                    ? 'postTopRightPOGW'
                    : 'postTopRight'
                } 
    ${darkTheme ? 'darkTheme blackBg' : ''}`}
              >
                {((post?.playerId ||
                  post?.user?.playerId ||
                  post?.userId?.playerId ||
                  post?.creator?.playerId ||
                  player?.playerId ||
                  '') === currentPlayerId ||
                  (post?.user?._id ||
                    post?.userId?._id ||
                    post?.creator?._id ||
                    post?.author?._id ||
                    '') === currentPlayerDbId ||
                  (galaxy &&
                    (galaxy.owners || []).some(
                      (owner) => owner._id === currentPlayer.data.player._id,
                    )) ||
                  (galaxy &&
                    (galaxy.administrators || []).some(
                      (admin) => admin._id === currentPlayer.data.player._id,
                    )) ||
                  (galaxy &&
                    (galaxy.moderators || []).some(
                      (moderator) =>
                        moderator._id === currentPlayer.data.player._id,
                    ))) && (
                  <IconButton
                    aria-label="more"
                    onClick={handleClick}
                    aria-haspopup="true"
                    aria-controls="long-menu"
                  >
                    <MoreVert
                      fontSize={!mobileView || width === 800 ? 'large' : 'small'}
                      style={{
                        color: darkTheme ? 'white' : 'inherit',
                      }}
                    />
                  </IconButton>
                )}
                {player.playerId === currentPlayer.data.player.playerId && (
                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={closePostMenu}
                    classes={{ paper: classes.menu }}
                  >
                    {MyOptions.map((option, i) => (
                      <MenuItem
                        key={i}
                        onClick={(event) => handleMenuOptionClick(event, option)}
                        className={classes.menuItem}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </Menu>
                )}
              </div>
            </div>
            {post?.isPogw && (
              <div>
                <Tooltip
                  title={`This post has ${(
                    Math.round(parseFloat(post?.jgkTokens) * 100) / 100
                  ).toFixed(2)} JGK`}
                >
                  <span
                    id="postJGKAmount"
                    className="postJGKAmount"
                    // className={
                    //   post?.jgkTokens < 9999
                    //     ? 'postNotificationIconBadgeJGK'
                    //     : 'postNotificationIconBadgeJGK10K'
                    // }
                  >
                    {post?.jgkTokens &&
                      (
                        Math.round(parseFloat(post?.jgkTokens) * 100) / 100
                      ).toFixed(2)}
                  </span>
                </Tooltip>
                <span className="postJGKBadge">JGK</span>
              </div>
            )}
            <div className="postTop">
              {localOpsMeta ? (
                <div className="localops-location-chip">{locationChip}</div>
              ) : post?.location?.coordinates ? (
                <div
                  className="flex-row"
                  style={{ textAlign: 'center', width: '100%' }}
                >
                  <Link
                    to={`/playerMap?lat=${post.location.coordinates[1]}&lon=${post.location.coordinates[0]}&parent=post`}
                    className="mmenu_header hover3"
                    title="View on map"
                  >
                    <Room
                      htmlColor="green"
                      className="shareIcon flashing-icon"
                    />
                  </Link>
                  {locationChip}
                </div>
              ) : null}
            </div>
            {localOpsMeta ? (
              <div className={localOpsHeroClassName}>
                <div className="localops-hero-header">
                  <div className="localops-signature">
                    <JGLocalOpsMark />
                  </div>
                  <div className="localops-hero-pills">
                    <span className="localops-pill-chip">
                      {localOpsMeta.entityType === 'offering'
                        ? 'Offering'
                        : localOpsCommunityTask
                        ? 'Community Task'
                        : 'Task'}
                    </span>
                    {localOpsCommunityTask ? (
                      <span className="localops-pill-chip">No cash payout</span>
                    ) : localOpsMeta.priceUsd ? (
                      <span className="localops-pill-chip localops-pill-chip--ready">
                        {localOpsMeta.escrowStatus === 'held' ? 'Funded' : 'Payment Ready'}
                      </span>
                    ) : null}
                    {localOpsMeta.offering?.requestQuote ? (
                      <span className="localops-pill-chip">Quote required</span>
                    ) : null}
                  </div>
                  <div className="localops-hero-region">{locationChip}</div>
                  {localOpsPresentation === 'feedExpanded' ? (
                    <button
                      type="button"
                      className="localops-compact-collapse"
                      onClick={onLocalOpsToggle || undefined}
                    >
                      Collapse
                    </button>
                  ) : null}
                </div>
                <div className="localops-hero-body">
                  <div className="localops-hero-avatar">
                    {player?.profilePhoto ||
                    localOpsMeta?.owner?.profilePhoto ||
                    post?.profilePhoto ? (
                      <img
                        src={
                          player?.profilePhoto ||
                          localOpsMeta?.owner?.profilePhoto ||
                          post?.profilePhoto
                        }
                        alt={localOpsOwnerDisplay}
                      />
                    ) : (
                      <span className="localops-avatar__fallback">
                        {localOpsOwnerDisplay.charAt(0)}
                      </span>
                    )}
                  </div>
                  <div className="localops-hero-text">
                    {localOpsOwnerProfileTarget ? (
                      <Link
                        className="localops-hero-owner localops-hero-owner-link"
                        to={localOpsOwnerProfileTarget}
                      >
                        {localOpsOwnerDisplay} {localOpsIsOwner ? '(You)' : ''}
                      </Link>
                    ) : (
                      <div className="localops-hero-owner">
                        {localOpsOwnerDisplay} {localOpsIsOwner ? '(You)' : ''}
                      </div>
                    )}
                    <div className="localops-hero-title">
                      {post.title ||
                        post.desc ||
                        localOpsMeta?.task?.title ||
                        localOpsMeta?.offering?.title ||
                        'LocalOps'}
                    </div>
                    {paymentDisplay.priceLine ? (
                      <div className="localops-hero-price">
                        {paymentDisplay.priceLine}
                        {paymentDisplay.escrowLine ? (
                          <span className="localops-hero-price-sub">
                            {paymentDisplay.escrowLine}
                          </span>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="localops-hero-actions">
                  {!localOpsIsOwner ? (
                    <button
                      type="button"
                      className="localops-hero-btn"
                      onClick={handleLocalOpsNavigate}
                    >
                      {primaryCtaOverride
                        ? primaryCtaOverride
                        : localOpsMeta.entityType === 'offering'
                        ? 'Reserve'
                        : 'Accept'}
                    </button>
                  ) : null}
                  <div className="localops-hero-secondary">
                    <button
                      type="button"
                      className="localops-hero-link"
                      onClick={handleLocalOpsNavigate}
                    >
                      View on map
                    </button>
                    {!isShareLanding && localOpsLink?.share ? (
                    <button
                      type="button"
                      className="localops-hero-link"
                      onClick={async () => {
                          const shareUrl = resolveShareUrl();
                          if (!shareUrl) return;
                          if (navigator.share) {
                            try {
                              await navigator.share({ url: shareUrl });
                            } catch (err) {
                              console.warn('navigator.share failed', err);
                            }
                            return;
                          }
                          try {
                            await navigator.clipboard.writeText(shareUrl);
                          } catch (err) {
                            console.warn('clipboard write failed', err);
                          }
                      }}
                    >
                      Share
                    </button>
                  ) : null}
                  </div>
                </div>
              </div>
            ) : null}
            <div className="postCenter" ref={imgRef}>
              {isEditingPost ? (
                <form
                  className="postEditForm"
                  aria-label="Edit post"
                  onSubmit={handleSavePostEdit}
                >
                  <div className="postEditHeader">
                    <div>
                      <span className="postEditTitle">Edit post</span>
                      <span className="postEditSubtitle">
                        {editMediaDraft.length}/{POST_EDIT_MAX_MEDIA} media
                      </span>
                    </div>
                  </div>
                  <label className="postEditTextareaShell">
                    <span className="postEditFieldLabel">Post text</span>
                    <textarea
                      className="postEditTextarea"
                      value={editDesc}
                      maxLength={POST_EDIT_MAX_LENGTH}
                      autoFocus
                      disabled={isSavingEdit}
                      aria-label="Edit post text"
                      onChange={(event) => {
                        setEditDesc(event.target.value);
                        if (editError) setEditError('');
                      }}
                    />
                  </label>
                  <input
                    ref={editFileInputRef}
                    className="postEditMediaInput"
                    type="file"
                    accept={POST_EDIT_FILE_ACCEPT}
                    multiple
                    disabled={isSavingEdit}
                    onChange={handlePostEditFileInput}
                  />
                  <div className="postEditMediaPanel">
                    <div className="postEditMediaHeader">
                      <div>
                        <span>Media</span>
                      </div>
                      <button
                        className="postEditMediaAdd"
                        type="button"
                        disabled={
                          isSavingEdit ||
                          editMediaDraft.length >= POST_EDIT_MAX_MEDIA
                        }
                        onClick={handlePickPostEditMedia}
                      >
                        Add media
                      </button>
                    </div>
                    {editMediaDraft.length > 0 ? (
                      <div className="postEditMediaGrid">
                        {editMediaDraft.map((item, index) => {
                          const previewUrl =
                            item.preview || getMediaThumbnailUrl(item) || item.url;
                          const isVideo = item.type === 'video';

                          return (
                            <div
                              className={
                                index === 0
                                  ? 'postEditMediaItem postEditMediaItemCover'
                                  : 'postEditMediaItem'
                              }
                              key={item.id}
                            >
                              <div className="postEditMediaPreview">
                                {isVideo ? (
                                  <video src={item.preview || item.url} muted />
                                ) : (
                                  <img src={previewUrl} alt="" />
                                )}
                                {index === 0 && (
                                  <span className="postEditMediaCover">Cover</span>
                                )}
                              </div>
                              <div className="postEditMediaControls">
                                {index > 0 && (
                                  <button
                                    type="button"
                                    disabled={isSavingEdit}
                                    aria-label={`Set cover for media ${index + 1}`}
                                    onClick={() => handleSetPostEditCover(index)}
                                  >
                                    Set cover
                                  </button>
                                )}
                                <button
                                  type="button"
                                  disabled={isSavingEdit}
                                  aria-label={`Remove media ${index + 1}`}
                                  onClick={() => handleRemovePostEditMedia(index)}
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <span className="postEditMediaEmpty">No media attached</span>
                    )}
                    {isSavingEdit && editUploadProgress > 0 && (
                      <div
                        className="postEditUploadProgress"
                        role="progressbar"
                        aria-label="Uploading post media"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        aria-valuenow={Math.min(100, editUploadProgress)}
                      >
                        <span
                          style={{
                            width: `${Math.min(100, editUploadProgress)}%`,
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="postEditMeta">
                    <span
                      className={
                        editCharsRemaining < 0
                          ? 'postEditLimit postEditLimitExceeded'
                          : 'postEditLimit'
                      }
                    >
                      {Math.max(0, editCharsRemaining)} left
                    </span>
                    {editError && (
                      <span className="postEditError" role="alert">
                        {editError}
                      </span>
                    )}
                  </div>
                  <div className="postEditActions">
                    <button
                      className="postEditButton"
                      type="button"
                      disabled={isSavingEdit}
                      onClick={handleCancelPostEdit}
                    >
                      Cancel
                    </button>
                    <button
                      className="postEditButton postEditButtonPrimary"
                      type="submit"
                      disabled={!canSavePostEdit}
                    >
                      {isSavingEdit ? 'Saving...' : 'Save'}
                    </button>
                  </div>
                </form>
              ) : (
                <DynamicHtml
                  from="post"
                  text={post?.desc}
                  setMessageTextIsVideo={setMessageTextIsVideo}
                />
              )}
              {!isEditingPost && (
                <PostMediaCarousel item={post} autoPlay={true} enableZoom={true} />
              )}
              {!isEditingPost && radioRotationDropMeta ? (
                <div
                  className="jg-radio-post-cta"
                  data-testid="jg-radio-rotation-drop-cta"
                >
                  <div className="jg-radio-post-cta__copy">
                    <span>JG RADIO ROTATION</span>
                    <strong>{radioRotationDropMeta.songTitle}</strong>
                    {radioRotationDropMeta.artistName ? (
                      <small>by {radioRotationDropMeta.artistName}</small>
                    ) : null}
                  </div>
                  <Link
                    className="jg-radio-post-cta__button"
                    to={radioRotationDropMeta.url}
                    onClick={handleRadioRotationDropClick}
                    aria-label={`${radioRotationDropMeta.label}: ${radioRotationDropMeta.songTitle} in JG Radio`}
                  >
                    <HearingIcon fontSize="small" aria-hidden="true" />
                    <span>{radioRotationDropMeta.label}</span>
                  </Link>
                </div>
              ) : null}
            </div>
            {/* LocalOps posts: hide JGK/share/comment affordances per spec */}
            {!localOpsMeta && (
              <div className="sendJGKToPostPOGWWrapper">
                {post?.isPogw && (
                  <span className="pogwTitleSpanMobile">POGW</span>
                )}
                <div className={jgkOnPost ? 'pogwIconIconClicked' : 'pogwIcon'}>
                  <Tooltip
                    title={
                      jgkOnPost
                        ? 'click to close JGK.'
                        : `click to give JGK to ${post?.playerId} for this post.`
                    }
                  >
                    <CurrencyExchangeOutlinedIcon
                      onClick={
                        post?.playerId !== loggedInPlayer.data.player.playerId
                          ? handleClickJGKOnPostToggle
                          : null
                      }
                      fontSize={!mobileView ? 'medium' : 'small'}
                    />
                  </Tooltip>
                </div>
                {!jgkOnPost && (
                  <>
                    <span
                      className={
                        !mobileView
                          ? darkTheme
                            ? 'postJgkdCounter dark-theme blackBg'
                            : 'postJgkdCounter'
                          : 'postJgkdCounterMobile'
                      }
                    >
                      JGK: {jgkTokens || 0}
                    </span>
                    <div className="postLikeProfileImgs">
                      {jgkd > 0 &&
                        post?.jgkdProfileImgs &&
                        post?.jgkdProfileImgs
                          .slice(0, numOfImages)
                          .map((jgkdProfileImg, i) => (
                            <Link
                              to={`/profile/${jgkdProfileImg.playerId}`}
                              key={i}
                            >
                              <img
                                src={
                                  jgkdProfileImg.profilePhoto
                                    ? jgkdProfileImg.profilePhoto
                                    : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                                }
                                alt=""
                                loading="lazy"
                                style={{
                                  transform: `translateX(${-i * 8}px)`,
                                  zIndex: `${i}`,
                                }}
                              />
                            </Link>
                          ))}
                    </div>
                  </>
                )}
                {jgkOnPost && (
                  <>
                    <div className="postJGKInputSend">
                      <div className="sendJGKToPostAmountInputs">
                        <label
                          className="sendJGKToPostAmountLabel"
                          htmlFor="sendJGKToPlayerAmount"
                        >
                          Amount:
                        </label>
                        <input
                          type="number"
                          value={sendJGKToPostAmount}
                          id="sendJGKToPlayerAmount"
                          onChange={(e) => setSendJGKToPostAmount(e.target.value)}
                          onKeyUp={handleSendJGKToPostAmount}
                        ></input>
                      </div>
                      <div className="sendJGKToPostPOGWButton">
                        <button
                          className={
                            !jgkOnPost || sendJGKToPostAmount < 1
                              ? 'sendJGKPostSubmitButtonDisabled'
                              : 'sendJGKPostSubmitButton'
                          }
                          value="Send"
                          disabled={sendJGKToPostAmount < 1 ? true : false}
                          onClick={handleSendJGKToPostAmount}
                        >
                          {isLoading ? (
                            <CircularProgress color="inherit" size="20px" />
                          ) : (
                            'Send'
                          )}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
            {!localOpsMeta ? (
              <>
                <div
                  className={
                    post?.isPogw
                      ? post?.jgkd.includes(loggedInPlayer.data.player.playerId) ||
                        post?.playerId === loggedInPlayer.data.player.playerId
                        ? 'postBottom'
                        : 'postBottom myDiv'
                      : 'postBottom'
                  }
                >
                  <Like
                    imgRef={imgRef}
                    text="+2 JGK, Yay!"
                    likes={like}
                    likesProfileImgs={post?.likesProfileImgs}
                    isLiked={isLiked}
                    likeHandler={likeHandler}
                    mobileView={mobileView}
                    PF={PF}
                    title={isLiked ? 'You liked this' : ''}
                    width={width}
                    textOffset={post?.isPogw ? -13 : -20}
                  />
                </div>
                <div style={{ margin: '6px 0' }}>
                  <ReactionBar
                    post={post}
                    currentPlayer={currentPlayer.data.player}
                    onReact={handleReact}
                  />
                </div>
              </>
            ) : null}

            {dialogIsSupported && (
              <div className="sharePostModal" title="Share Post">
                <div className="shareCountDiv">
                  <div className="sendOutlinedIcon">
                    <SendOutlinedIcon
                      onClick={() => {
                        setModal(true);
                      }}
                    />
                  </div>
                  <span className="postRePostCounter">
                    {share > 0 ? share : null}
                  </span>
                  <span
                    className={
                      !mobileView ? 'postLikeCounter' : 'postLikeCounterMobile'
                    }
                  >
                    {width > 280 &&
                      (share === 1
                        ? ' share'
                        : share > 1
                        ? ' shares '
                        : 'be 1st to share ')}
                  </span>
                </div>

                <Modal openModal={modal}>
                  <div
                    className={
                      darkTheme
                        ? 'modalContent darkTheme blackBg'
                        : 'modalContent'
                    }
                  >
                    <div className="modalHeaders">
                      {!isRepost && (
                        <div className="shareDiv">
                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check
                                  ref={checkbox}
                                  type={type}
                                  id={`${player._id}`}
                                  // label={` Share`}
                                  onClick={(e) => {
                                    handleIsShareClicked();
                                  }}
                                />
                              </div>
                            ))}
                          </Form>
                          <h2 className="modalHeader">Share</h2>
                        </div>
                      )}

                      {!isShare &&
                        loggedInPlayer.data.player.playerId !==
                          post?.playerId && (
                          <div className="repostDiv">
                            <Form>
                              {['checkbox'].map((type) => (
                                <div key={`default-${type}`} className="mb-3">
                                  <Form.Check
                                    ref={checkbox}
                                    type={type}
                                    id={`${player._id}`}
                                    // label={` Share`}
                                    onClick={(e) => handleIsRepostClicked()}
                                  />
                                </div>
                              ))}
                            </Form>
                            <h2 className="modalHeader">Repost</h2>
                          </div>
                        )}
                    </div>
                    {!isRepost && (
                      <>
                        <div>To: </div>
                        <div
                          className={
                            darkTheme
                              ? 'postRequestPlayersSearchResults darkTheme blackBg'
                              : 'postRequestPlayersSearchResults'
                          }
                        >
                          {
                            <MyFriendsToSharePost
                              searchedPlayers={myFriends}
                              myFriendsToSharePost={myFriendsToSharePost}
                              SetMyFriendsToSharePost={SetMyFriendsToSharePost}
                            />
                          }
                        </div>
                      </>
                    )}

                    <div className="postShareCloseSend topright">
                      <button
                        className="sharePostSubmitButton"
                        onClick={() => {
                          setModal(false);
                        }}
                      >
                        x
                      </button>
                    </div>

                    <div className="postShareCloseSend">
                      <button
                        className={
                          (myFriendsToSharePost &&
                            myFriendsToSharePost.length > 0) ||
                          isRepost
                            ? 'sharePostSubmitButton'
                            : 'sharePostSubmitButtonDisabled'
                        }
                        onClick={isShare ? handleSharePost : handleRepost}
                        disabled={
                          (myFriendsToSharePost &&
                            myFriendsToSharePost.length > 0) ||
                          isRepost
                            ? false
                            : true
                        }
                      >
                        {loading ? (
                          <CircularProgress color="inherit" size="20px" />
                        ) : isShare ? (
                          'Send'
                        ) : (
                          'Go'
                        )}
                      </button>
                    </div>
                  </div>
                </Modal>
              </div>
            )}
            <div
              className={
                post?.isPogw
                  ? post?.jgkd.includes(loggedInPlayer.data.player.playerId) ||
                    post?.playerId === loggedInPlayer.data.player.playerId
                    ? 'commentBottom'
                    : 'commentBottom myDiv'
                  : 'commentBottom'
              }
            >
              <div className="comments_wrap">
                <CreateComment
                  postId={post?._id}
                  setComments={setComments}
                  setCommentCount={setCommentCount}
                  parent="Post"
                  socket2={socket2}
                />
                {commentTypingHint && (
                  <div
                    style={{
                      fontSize: 12,
                      color: '#6c63ff',
                      margin: '4px 2px 6px',
                      fontWeight: 600,
                    }}
                  >
                    {commentTypingHint}
                  </div>
                )}

                <span className="postCommentText">
                  {sortedComments
                    .slice(0, commentCountRef.current)
                    .map((comment) => (
                      <Comment
                        comment={comment}
                        key={comment._id}
                        postId={post?._id}
                        imgRef={imgRef}
                        parentOwnerPlayerId={post?.playerId}
                        onDelete={handleCommentDeleted}
                      />
                    ))}
                  {commentCountRef.current <
                    (comments ? comments?.length : 0) && (
                    <div
                      className={`${
                        !mobileView ? 'viewComments' : 'viewCommentsMobile'
                      } ${darkTheme ? 'app dark-theme' : ''}`}
                      onClick={() => showMore()}
                    >
                      View {comments?.length - commentCountRef.current} more{' '}
                      {comments?.length - commentCountRef.current === 1
                        ? 'comment'
                        : 'comments'}
                    </div>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Tooltip>
    </>
  );
}






